namespace Matrix {
    export interface SupportTicketSendEmailResponse extends Serenity.ServiceResponse {
    }
}
